/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ContextItem, ExtendedJsonSchema } from '@squiz/dxp-ai-client';
import React, { ReactElement } from 'react';
import { formatColumnValue } from './formatColumnValue';

export const getColumnValues = (
  schema: ExtendedJsonSchema,
  data: ContextItem,
  keys: Array<string>,
): Record<string, ReactElement> => {
  const result: Record<string, ReactElement> = {};

  for (const path of keys) {
    const pathParts = path.split('/');
    let propertySchema = schema;
    let value = data.data;

    for (let i = 0; i < pathParts.length; i++) {
      const key = pathParts[i];

      if (key in value && propertySchema.properties && key in propertySchema.properties) {
        propertySchema = propertySchema.properties[key];
        value = value[key];

        if (i < pathParts.length - 1) {
          // not at a leaf, continue to the next level.
          continue;
        }

        result[path] = <span data-id={propertySchema.title}>{formatColumnValue(value, propertySchema)}</span>;
      }
    }
  }

  return result;
};
